<template>
    <table class="table">
        <thead>
            <tr>
                <th scope="col" style="padding-left: 20px;">#ID</th>
                <th scope="col">{{ $t('companyusers.text_13') }}</th>
                <th scope="col">{{ $t('companyusers.text_14') }}</th>
                <th scope="col">{{ $t('companyusers.text_15') }}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="user in users" :key="user.id">
                <th>{{user.id}}</th>
                <td>{{user.email}}</td>
                <td style="white-space: normal;">
                    {{user.meno}} {{user.priezvisko}}
                </td>
                <td style=" position: relative; display: flex; align-items: center;">
                    <a :title="$t('companyusers.text_16')" class="my_tooltip m-r-15 ">
                        <span class="my_tooltiptext">{{ $t('companyusers.text_16') }}</span>
                        <i @click="$emit('edit',user)" class="icon feather icon-edit f-w-600 f-16 text-c-green"></i>
                    </a>
                    <a :title="$t('companyusers.text_17')" class="my_tooltip m-r-15">
                        <span class="my_tooltiptext">{{ $t('companyusers.text_17') }}</span>
                        <i @click="$emit('remove',user)" class="fa fa-trash-o f-w-600 f-16 text-danger"></i>
                    </a>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        props: ['users']
    }
</script>

<style lang="scss" scoped>
    .my_tooltip{
        cursor: pointer;
    }
    .table > thead > tr{
        border-bottom: 1px solid #dee2e6;
    }
    .table > thead > tr > th{
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
        padding: 1.3rem .5rem;
        border-bottom: none;
    }
    .table > tbody > tr {
        border-top: none;
        border-bottom: 1px solid #dee2e6;
        th{
            padding: 1.3rem .5rem;
            padding-left: 20px;
        }
        td{
            padding: 1.3rem .5rem;
        }
    }
</style>    